import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../fundManagement/fundmanagement.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCompanyDetails,
  companyListBackDetails,
} from "../../store/actions/rateCard";
import { Button } from "bootstrap-4-react/lib/components";
import BatchPagination from "../batch/BatchPagination";
import AddCompanyModal from "../modal/AddCompanyModal";
import FilterCompany from "../company-Seller-Filter";
import CompanyList from "./list";
import WalletSummaryBar from "./WalletSummaryBar";
import CompanyDetailsPopup from "./CompanyDetailsPopup";
import CompanyOnboardingReviewModal from "./CompanyOnboardingReviewModal";
import _ from "lodash";
import { checkPermission } from "../../config/utils";
import { accountsManagement, featureSubmodulePermission, permssionCreate, SUBF_COMPANY } from "../../constant";
import SearchProduct from "../Inventory/Product/searchProduct";
import PropTypes from "prop-types";
import moment from "moment";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { exportCompanySellersService } from "../../services/company.service";

const EXPORT_ERROR_MESSAGE = 'Unable to export companies. Please try again.';

const readBlobAsText = (blob) => {
  if (!(blob instanceof Blob)) {
    return Promise.resolve('');
  }
  if (typeof blob.text === 'function') {
    return blob.text().catch(() => '');
  }
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = () => resolve('');
    reader.readAsText(blob);
  });
};

// Error responses of the export endpoint are JSON delivered as a blob
const getExportErrorMessage = async (error) => {
  const text = await readBlobAsText(error?.response?.data);
  try {
    const body = JSON.parse(text);
    return body?.Message?.AppStatusDescription || body?.message?.appStatusDescription || EXPORT_ERROR_MESSAGE;
  } catch {
    return EXPORT_ERROR_MESSAGE;
  }
};

const CompanyManagement = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getAllCompany, getAllCompanyStatus, companyBackDetails } = useSelector((state) => state.RateCardReducer);
  const UserValue = useSelector((state) => state.auth.user);
    
  const [companyModalShow, setcompanyModalShow] = React.useState(false);
  const [totalPages, setTotalPages] = useState(1);
  let dataLoad = {
    pageIndex: 1,
    pageSize: 30,
    sortColumn: "id",
    sortOrder: 'DESCENDING',
    showFilter: false,
    showSearch: true,
    country: '',
    state: [],
  };
  const [filterValue, setFilterValue] = useState({});
  const numOfPage = [30, 50, 100, 200, 500, 1000, 2000];
  const [loader, setLoader] = useState(false);
  const [popupState, setPopupState] = useState({ open: false, company: null, initialTab: 'sellers' });
  const [onboardingState, setOnboardingState] = useState({ open: false, company: null });
  const [exporting, setExporting] = useState(false);
  // Query behind the list currently on screen, so the export always matches the grid
  const lastQueryRef = useRef(null);

  useEffect(() => {
    if (!_.isEmpty(companyBackDetails)) {
      setFilterValue({ ...filterValue, ...companyBackDetails });
    } else {
      setFilterValue({ ...dataLoad });
    }
  }, [])

  useEffect(() => {
    if (getAllCompanyStatus === 'PENDING') {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [getAllCompanyStatus])

  useEffect(() => {
    if (!_.isEmpty(filterValue)) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue.pageSize, filterValue.pageIndex, filterValue.sortColumn, filterValue.sortOrder, filterValue.state, filterValue.country, filterValue.balanceStatus, filterValue.minWalletBalance, filterValue.maxWalletBalance, filterValue.createdDateFrom, filterValue.createdDateTo, filterValue.isActive]);

  const isSuperAdmin = !!UserValue?.Value?.isSuperAdmin;

  const buildFilterData = (overrides = {}) => {
    const merged = { ...filterValue, ...overrides };
    const labels = Array.isArray(merged?.state) ? merged?.state?.map(i => i.label) : merged?.state;
    const data = { ...merged, state: labels };
    if (isSuperAdmin) {
      data.minWalletBalance = merged.minWalletBalance ?? null;
      data.maxWalletBalance = merged.maxWalletBalance ?? null;
      data.balanceStatus = merged.balanceStatus || null;
      data.includeWalletSummary = true;
    } else {
      delete data.minWalletBalance;
      delete data.maxWalletBalance;
      delete data.balanceStatus;
    }
    return data;
  };

  const fetchData = () => {
    loadCompanies(buildFilterData());
  }

  const loadCompanies = (queryData) => {
    lastQueryRef.current = queryData;
    dispatch(getAllCompanyDetails(setTotalPages, filterValue.pageSize, filterValue.pageIndex, queryData));
  };

  const handleExport = async () => {
    if (exporting) return;
    setExporting(true);
    try {
      const query = _.omit(lastQueryRef.current || buildFilterData(), ['showFilter', 'showSearch']);
      const response = await exportCompanySellersService({
        ...query,
        searchKeywords: query.searchKeywords?.trim(),
        includeWalletSummary: false,
      });
      saveAs(response.data, `CompanySellers_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
    } catch (error) {
      toast.error(await getExportErrorMessage(error));
    } finally {
      setExporting(false);
    }
  };

  const handleSegmentSelect = (status) => {
    setFilterValue({ ...filterValue, balanceStatus: status, pageIndex: 1 });
  };

  const handleAssociatedSellerPage = (companyId) => {
    const companyRow = (getAllCompany?.Entity?.listCompanyMasterOrdersEntity || []).find(c => c?.Id === companyId);
    setPopupState({ open: true, company: companyRow || { Id: companyId }, initialTab: 'sellers' });
  };
  const handleAssociatedUserPage = (companyId) => {
    const companyRow = (getAllCompany?.Entity?.listCompanyMasterOrdersEntity || []).find(c => c?.Id === companyId);
    setPopupState({ open: true, company: companyRow || { Id: companyId }, initialTab: 'users' });
  };
  const handleCompanyOnboardingReview = (companyRow) => {
    setOnboardingState({ open: true, company: companyRow });
  };

  const handleSortingCoulmn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = filterValue.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setFilterValue({
      ...filterValue,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
    });
  };

  const handleFilterToggle = (key, value) => {
    setFilterValue({ ...filterValue, [key]: value });
  }

  const handleSearchText = (searchTxt) => {
    setFilterValue({ ...filterValue, searchKeywords: searchTxt });
  }

  const handleSearchFilter = (e, type) => {
    if (type === 'clear') {
      setFilterValue({ ...filterValue, searchKeywords: '' });
      loadCompanies(buildFilterData({ searchKeywords: '' }));
    } else {
      fetchData();
    }
  }

  return (
    <main>
      {companyModalShow && (
        <AddCompanyModal
          show={companyModalShow}
          onHide={() => setcompanyModalShow(false)}
        />
      )}

      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          Company Management
          <div className="top_right_button_container">
            <div className="selectYear filterIncoming">
              <Button
                className="cus-seconday-bg-btn top-btn FilterButton"
                onClick={() => handleFilterToggle('showFilter', !filterValue.showFilter)}
              >Filter
              </Button>
            </div>
            <Button
              className="cus-seconday-bg-btn top-btn"
              onClick={handleExport}
              disabled={exporting}
            >
              {exporting ? 'Exporting...' : 'Export'}
            </Button>
            {UserValue.Value?.isSuperAdmin && checkPermission(accountsManagement, SUBF_COMPANY, permssionCreate, featureSubmodulePermission, props.employeePermissions) && (
              <Button
                className="cus-seconday-bg-btn cusbtn"
                onClick={() => setcompanyModalShow(true)}

              >
                Add Company
              </Button>
            )}
          </div>
        </div>
        {isSuperAdmin && (
          <WalletSummaryBar
            summary={getAllCompany?.Entity?.walletSummary}
            activeStatus={filterValue.balanceStatus}
            onSelect={handleSegmentSelect}
          />
        )}
        <SearchProduct
          showSearch={filterValue.showSearch}
          searchTxt={filterValue.searchKeywords}
          setSearchTxt={handleSearchText}
          handleReset={handleSearchFilter}
          handleSearchFilter={handleSearchFilter}
          placeHolderText="Search by Company Name, Seller Name, Seller Code or STE Code"
        />
        {filterValue.showFilter && (
          <FilterCompany
            setfilterData={setFilterValue}
            filterData={filterValue}
            dataLoad={dataLoad}
            showWalletFilter={isSuperAdmin}
            showCreatedFilters
          />
        )}
        <div className="main_content_table_history">
          <div className="tableFixHead incomingTbl">
            <CompanyList
              {...props}
              sortingColumn={filterValue.sortColumn}
              handleSortingCoulmn={handleSortingCoulmn}
              sortOrder={filterValue.sortOrder}
              getAllCompany={getAllCompany}
              handleAssociatedSellerPage={handleAssociatedSellerPage}
              handleAssociatedUserPage={handleAssociatedUserPage}
              handleCompanyOnboardingReview={handleCompanyOnboardingReview}
              navigate={navigate}
              loader={loader}
              filterData={filterValue}
              refreshList={fetchData}
            />
          </div>
        </div>
        {getAllCompany?.Entity?.listCompanyMasterOrdersEntity && (
          <BatchPagination
            gridData={getAllCompany?.Entity?.listCompanyMasterOrdersEntity}
            totalVisualRecords={
              getAllCompany?.Entity?.listCompanyMasterOrdersEntity.length
            }
            numberOfPage={filterValue.pageSize}
            numOfPage={numOfPage}
            currentPage={filterValue.pageIndex}
            totalPages={totalPages || 0}
            totalRecords={getAllCompany?.Entity?.TotalRecords}
            setCurrentPage={(value) => setFilterValue({ ...filterValue, pageIndex: value })}
            setNumberOfPage={(value) => setFilterValue({ ...filterValue, pageSize: value })}
          />
        )}
      </div>
      <CompanyDetailsPopup
        open={popupState.open}
        company={popupState.company}
        initialTab={popupState.initialTab}
        onClose={() => setPopupState({ open: false, company: null, initialTab: 'sellers' })}
        employeePermissions={props.employeePermissions}
        filterData={filterValue}
      />
      <CompanyOnboardingReviewModal
        open={onboardingState.open}
        company={onboardingState.company}
        onClose={() => setOnboardingState({ open: false, company: null })}
      />
    </main>
  );
}

CompanyManagement.propTypes = {
  employeePermissions: PropTypes.array
};

export default CompanyManagement;